// Mark assets as loaded
window.ahaLoaded = true;

if (window.overrideAssetHost) {
  // eslint-disable-next-line no-undef
  __webpack_public_path__ = window.overrideAssetHost;
}

import 'iripo';

const requireAll = r =>
  r
    .keys()
    .filter(key => !key.includes('.test.'))
    .forEach(r);

// Require styles.
import '@aha-app/aha-icon';
import '@aha-app/aha-base/dist-vars/variables.css';
import '@aha-app/aha-base/dist/assets/font-awesome/all.css';

// Require npm styles.
import '@aha-app/bootstrap-datepicker/dist/css/@aha-app/bootstrap-datepicker';
// Import AhaBase library, which defines a number of basic styles for common and cross-property components.
import '@aha-app/aha-base/dist/index.less';

// Require application styles.
import 'stylesheets/idea_portals/new/manifest';
import 'stylesheets/flush_tabs';
import 'stylesheets/popdown';
import 'stylesheets/drawer-nav';
import 'stylesheets/tabbed_details';
import 'stylesheets/attributes';
import 'stylesheets/record_reference_pill';
import 'stylesheets/share_as_webpage';
import 'stylesheets/selectro_v2_templates';
import 'stylesheets/selectrov2';
import 'stylesheets/user_content';

//  Require vendor dependencies.
import 'javascripts/jquery-ui-1.13.2.custom';
import 'javascripts/bootstrap-plugins';
import 'javascripts/aha-tooltip';
import windowRequire from 'javascripts/idea_portals/window_require';
window.require = windowRequire;
import Turbolinks from 'javascripts/turbolinks';
window.Turbolinks = Turbolinks;

//  Require npm dependencies.
import '@aha-app/bootstrap-datepicker';
import '@aha-app/selectro';
import '@aha-app/react-in-place/dist/ReactInPlace.less';
import 'jquery-ujs';

import '@aha-app/selectro/lib/assets/stylesheets/selectro.css.less';
import '@aha-app/whiteboard/dist/index.css';
import '@aha-app/whiteboard/dist/SidePanel.css';
import '@aha-app/aha-editor/dist/index.css';

// Add Tailwind styles last, so they predictably override other styles of the same specificity.
import 'stylesheets/tailwind_compiled.css'; // not tailwind.css

//  Require local assets.
import 'javascripts/templates';
import 'javascripts/portals_callbacks';
import 'javascripts/popdown.js';
requireAll(require.context('javascripts/idea_portals', false, /\.(js|ts)$/));
requireAll(
  require.context('javascripts/idea_portals/new_theme', false, /\.(js|ts)$/)
);

import {
  loadRecordPreviews,
  loadPublishedFilterContainer,
  loadWhiteboard,
} from 'javascripts/async_modules';

// Initialize listener to mount React components on pageload/navigation.
import SectionTabs from 'components/ideas_portals/SectionTabs';
import Poll from 'components/Polls/Poll';
import { addListener } from 'javascripts/react_mount';
import * as Attributes from 'components/common/Attributes';
import SelectroV2 from '@aha-app/selectro-v2';
import { AhaEditorFieldV2 } from 'components/aha_editor_field_v2/LazyAhaEditorFieldV2';
import { AhaNewRecordEditor } from 'components/aha_new_record_editor/LazyAhaNewRecordEditor';

const components = {
  AhaEditorFieldV2: () => AhaEditorFieldV2,
  AhaEditorCustomFieldValueV2: () => AhaEditorFieldV2,
  AhaNewRecordEditor: () => AhaNewRecordEditor,
  'Attributes.Attribute': () => Attributes.Attribute,
  SectionTabs: () => SectionTabs,
  Poll: () => Poll,
  RecordPreviews: loadRecordPreviews,
  PublishedFilterContainer: loadPublishedFilterContainer,
  SelectroV2: () => SelectroV2,
  Whiteboard: loadWhiteboard,
};
addListener(components);

import { defineCustomElements } from '@aha-app/aha-base/dist/components';
defineCustomElements();
